<template>
  <div class="modal-confirm picker-modal" :class="{ active }">
    <div class="overlay" @click="onCancel"></div>
    <div class="content">
      
      <slot />

      <div class="actions">
        <button @click="onCancel">{{ $t('picker-modal.cancel') }}</button>
        <button class="primary" @click="onOkay">{{ $t('picker-modal.ok') }}</button>
      </div>      
    </div>
  </div>
</template>

<script>
export default {
  props: ['active'],
  methods: {
    onCancel() {
      this.$emit('modal-cancel');
    },

    onOkay() {
      this.$emit('modal-confirm');
    }
  }
}
</script>